import { render, staticRenderFns } from "./PBDPagination.vue?vue&type=template&id=0224db95&"
import script from "./PBDPagination.vue?vue&type=script&lang=js&"
export * from "./PBDPagination.vue?vue&type=script&lang=js&"
import style0 from "./PBDPagination.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports